import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import moment from 'moment'
import { rem } from 'polished'
import { useCallback, useContext, useMemo } from 'react'
import styled from 'styled-components'

import DualDateRangePicker from 'components/Common/Calendar/DualDateRangePicker'
import VerticalDateRangePicker from 'components/Common/Calendar/VerticalDateRangePicker'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'

const CalendarContainer = styled.div`
  box-sizing: border-box;
  padding: 0 ${rem(16)};
`

interface Props {
  drawerMode?: boolean
  availableMonths?: Array<string>
  onChange: (value: App.CruiseGlobalFilters) => void
}

function CruiseWhenSelectCalendar(props: Props) {
  const {
    drawerMode,
    availableMonths,
    onChange,
  } = props
  const today = useMemo(() => new Date(), [])
  const max = useMemo(() => moment(today).add(2, 'year').endOf('year').toDate(), [today])

  const {
    checkinDate: startDate,
    checkoutDate: endDate,
  } = useContext(GlobalSearchStateContext)

  const searchDispatch = useContext(GlobalSearchDispatchContext)

  const onDayClick = useCallback((dates: {
    startDate: moment.Moment
    endDate?: moment.Moment
  }) => {
    const start = dates.startDate
    const end = dates.endDate
    let checkinCheckout = {}
    if (start && end) {
      searchDispatch({ type: GlobalSearchStateActions.SET_CHECKIN_DATE, date: startDate })
      searchDispatch({ type: GlobalSearchStateActions.SET_CHECKOUT_DATE, date: end })

      // when selecting a date range, we want to reset the flexible months
      searchDispatch({ type: GlobalSearchStateActions.SET_FLEXIBLE_MONTH_RANGE, flexibleMonths: '' })
      checkinCheckout = { checkinDate: startDate, checkoutDate: end }
    } else {
      searchDispatch({ type: GlobalSearchStateActions.SET_CHECKIN_DATE, date: start })
      searchDispatch({ type: GlobalSearchStateActions.UNSET_CHECKOUT_DATE })
      checkinCheckout = { checkinDate: start, checkoutDate: undefined }
    }

    const isCruiseSearch = window.location.pathname.includes('search/cruise')
    if (isCruiseSearch) {
      onChange(checkinCheckout)
    }
  }, [onChange, searchDispatch, startDate])

  return <CalendarContainer data-testid="cruise-when-select-calendar">
    {drawerMode && (
      <VerticalDateRangePicker
        availableMonths={availableMonths}
        onDatesChange={onDayClick}
        min={today}
        max={max}
        startDate={startDate}
        endDate={endDate}
      />
    )}
    {!drawerMode && (
      <DualDateRangePicker
        availableMonths={availableMonths}
        onDatesChange={onDayClick}
        minDate={today}
        maxDate={max}
        startDate={startDate}
        endDate={endDate}
      />
    )}
  </CalendarContainer>
}

export default CruiseWhenSelectCalendar
